import { render, staticRenderFns } from "./ForceResetPassword.vue?vue&type=template&id=7ef958ea&"
import script from "./ForceResetPassword.vue?vue&type=script&lang=js&"
export * from "./ForceResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ForceResetPassword.vue"
export default component.exports